const isEven = int => int % 2 == 0
export default isEven
